<template>
  <div style="background-color: #fff;padding: 22px 0;">
    <ul class="timeline">
      <li
        class="timeline-item"
        v-for="(item,index) in activities"
        :key="item.index"
      >
        <div class="item-tail"></div>
        <div class="item-node"></div>
        <div
          class="item-wrapper"
          :class="index % 2 == 0?'':'item-wrapper-right'"
        >
          <div
            class="item-time"
            ref="time"
          >{{ item.timestamp }}</div>
          <div class="item-content">{{item.content}}</div>

        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activities: [
        {
          timestamp: "2021年",
          content: "成立弘知商学院，集团业务多元化发展",
        },
        {
          timestamp: "2020年",
          content: "线上教育模式取得突破性成果，教研体系全面升级,线上产品面市",
        },
        {
          timestamp: "2019年",
          content: "成立旗下弘朗教育培训有限公司，成立隽朗科技有限公司",
        },
        {
          timestamp: "2018年",
          content: "成立旗下弘之道教育培训有限公司，成立弘知教育党支部",
        },
        {
          timestamp: "2017年",
          content: "青竹湖教学点升级为青竹湖校区，同年成立麓山国际教学点",
        },
        {
          timestamp: "2016年",
          content: "成立弘知培训学校有限公司，各学科教研组相继成立",
        },
        {
          timestamp: "2015年",
          content: "2015年—中教学点成立,学子频频在各类竞赛中获奖,口碑逐渐形成",
        },
        {
          timestamp: "2014年",
          content: "青竹湖教学点成立，同年在青竹湖片区形成良好的品牌效应",
        },
        {
          timestamp: "2013年",
          content: "长梅教学点成立，设立物理学科组、化学学科组",
        },
      ],
    };
  },
  components: {},
  methods: {},
};
</script>
<style scoped>
.timeline {
  margin: 0;
  font-size: 14px;
  list-style: none;
  margin: 20px;
  position: relative;
  left: 50%;
  font-weight: 400;
}

.timeline-item {
  position: relative;
  padding-bottom: 20px;
}

.item-tail {
  position: absolute;
  left: 4px;
  height: 100%;
  border-left: 2px solid #e4e7ed;
}
.item-node {
  left: 1px;
  width: 4px;
  height: 4px;
  position: absolute;
  background-color: #d8d8d8;
  border: 2px solid #d8d8d8;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.item-wrapper {
  position: relative;
  padding-left: 28px;
  top: -3px;
  width: 378px;
}

.item-content {
  /* font-weight: 600; */
  margin-top: 6px;
}
.item-time {
  line-height: 1;
  font-size: 20px;
  font-family: 'PingFang-Bold';
}
.item-process {
  margin-top: 8px;
}
.item-result {
  margin-top: 8px;
}
.item-wrapper-right {
  right: 424px;
  text-align: right;
}
</style>